export let WarehousePaymentType = /*#__PURE__*/function (WarehousePaymentType) {
  WarehousePaymentType["Payment"] = "Payment";
  WarehousePaymentType["Adjustment"] = "Adjustment";
  return WarehousePaymentType;
}({});